<template>
	<section class="account">
		<template
			v-if="initialized && isLoggedIn"
		>
			<div class="divider">
				<div class="divider__left">
					<div class="account__header insicht insicht--fade-in">
						<span
							class="account__header-title"
							v-html="$t('account.title')"
						/>
						<h1
							class="account__header-name"
							v-html="`${accountUserDetail.firstName} ${accountUserDetail.lastName}`"
						/>
						<Button
							class="account__header-logout"
							type="button"
							level="tertiary"
							:text="$t('account.logoutButton')"
							@click.prevent="onLogout"
							arrow
						/>

						<ul class="account__header-points">
							<li class="account__header-points-item">
								<span
									class="account__header-points-value"
									v-html="accountClub.pointsTotal"
								/>
								<span
									class="account__header-points-label"
									v-html="$t('account.kangaroo.pointsTotal')"
								/>
							</li>
							<li class="account__header-points-item">
								<span
									class="account__header-points-value"
									v-html="accountClub.points"
								/>
								<span
									class="account__header-points-label"
									v-html="$t('account.kangaroo.pointsAvailable')"
								/>
							</li>
						</ul>

						<ul class="account__header-points">
							<li class="account__header-points-item">
								<span
									class="account__header-points-value"
									v-html="accountReferralCount"
								/>
								<span
									class="account__header-points-label"
									v-html="$t('account.referral.referralCount')"
								/>
							</li>
						</ul>

						<div class="account__header-block">
							<h2
								class="account__header-block-title"
								v-html="$t('account.emailTitle')"
							/>
							<div
								class="account__header-block-text"
								v-html="accountUserDetail.email"
							/>
							<!-- <Button
								class="account__edit-button"
								type="button"
								level="tertiary"
								:text="$t('account.userDetailEdit.edit')"
								@click.prevent="onUserDetailEdit"
								arrow
							/> -->
						</div>

						<div class="account__header-block">
							<h2
								class="account__header-block-title"
								v-html="$t('account.addressTitle')"
							/>
							<address
								v-if="formattedAddress"
								class="account__header-block-text"
								v-html="formattedAddress"
							/>
							<div
								v-else
								class="account__header-block-text"
								v-html="$t('account.noAddress')"
							/>
							<Button
								class="account__edit-button"
								type="button"
								level="tertiary"
								:text="$t('account.addressEdit.edit')"
								@click.prevent="onAddressEdit"
								arrow
							/>
						</div>

						<div class="account__header-block">
							<h2
								class="account__header-block-title"
								v-html="$t('account.passwordResetTitle')"
							/>
							<div
								class="account__header-block-text"
								v-html="$t('account.passwordResetText')"
							/>
							<Button
								class="account__edit-button"
								type="button"
								level="tertiary"
								:text="$t('account.passwordResetButton')"
								@click.prevent="onPasswordChange"
								arrow
							/>
						</div>

						<div
							class="account__header-block"
							v-if="accountUserDetail.groups && accountUserDetail.groups.length"
						>
							<h2
								class="account__header-block-title"
								v-html="$t('account.groupsTitle')"
							/>
							<ul class="account__groups-list">
								<li
									class="account__groups-item"
									v-for="(group, index) in accountUserDetail.groups"
									:key="`${index}-${group.name}`"
									v-html="group.name"
								/>
							</ul>
						</div>

					</div>
				</div>
				<div class="divider__right">
					<a class="anchor" id="points"/>
					<div class="account__block insicht insicht--fade-in">
						<div class="account__points">
							<div class="account__points-wrapper">
								<div class="account__points-header">
									<div class="account__points-level">
										<div
											class="account__points-level-label"
											v-html="$t('account.kangaroo.currentLevel')"
										/>
										<div
											class="account__points-level-name"
											v-html="accountClub.tierLevel"
										/>
									</div>
									<Button
										class="account__points-header-link"
										type="button"
										level="tertiary"
										:text="$t('account.kangaroo.levelLinkText')"
										:href="$t('account.kangaroo.levelLinkUrl')"
										arrow
									/>
								</div>


								<div class="account__points-progress">
									<div class="account__points-progress-step">
										<div
											class="account__points-progress-value"
											v-html="accountClub.pointsTotal"
										/>
										<div
											class="account__points-progress-label"
											v-html="$t('account.kangaroo.pointsTotal')"
										/>
									</div>
									<div class="account__points-progress-step">
										<div
											class="account__points-progress-value"
											v-html="accountClub.pointsToNext"
										/>
										<div
											class="account__points-progress-label"
											v-html="$t('account.kangaroo.pointsToNext')"
										/>
									</div>
									<div class="account__points-progress-step">
										<div
											class="account__points-progress-level"
											v-html="accountClub.nextTierLevel || accountClub.tierLevel"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<template v-if="accountClaimableCoupons.length">
						<a class="anchor" id="rewards"/>
						<div class="account__block insicht insicht--fade-in">
							<h2 class="account__block-title" v-html="$t('account.kangaroo.rewardsTitle')"/>
							<div class="account__block-text" v-html="$t('account.kangaroo.rewardsText')"/>

							<GeneralMessage
								v-if="redeemResponse.message"
								:message="redeemResponse.message"
								:type="redeemResponse.type"
								@close="redeemResponse.message = ''"
							/>

							<div class="content-slider">
								<vue-glide
									class="account__claimable-coupons"
									ref="glide"
									v-bind="glideOptions"
								>
									<vue-glide-slide
										class="account__claimable-coupon"
										v-for="coupon in accountClaimableCoupons"
										:key="coupon.code"
									>
										<div class="media-container media-container--ratio-4-3">
											<img
												class="account__claimable-coupon-image"
												:src="coupon.image"
												alt="Coupon Image"
												data-object-fit
												loading="lazy"
											>
										</div>
										<Button
											class="account__claimable-coupon-button"
											level="primary"
											:text="$t('account.kangaroo.coupons.redeem', {points: coupon.points})"
											:disabled="!coupon.eligible"
											:variants="[
												'block',
												'small',
											]"
											@click="redeemCoupon(coupon)"
										/>
										<h3
											class="account__claimable-coupon-title"
											v-html="coupon.label"
										/>
										<span
											class="account__claimable-coupon-subtitle"
											v-html="$t('account.kangaroo.coupons.storeCredit', {value: formatDiscount(coupon.amount), points: coupon.points})"
										/>
									</vue-glide-slide>
								</vue-glide>
							</div>
						</div>
					</template>

					<a class="anchor" id="discounts"/>
					<div class="account__block insicht insicht--fade-in">
						<h2 class="account__block-title" v-html="$t('account.couponsTitle')"/>
						<div class="account__block-text" v-html="$t('account.couponsText')"/>
						<table
							class="account__coupons"
							v-if="accountCoupons.length"
						>
							<tr
								class="account__coupon"
								v-for="(coupon, index) in accountCoupons"
								:key="`coupon-${index}`"
							>
								<td class="account__coupon-cell">
									<span class="account__coupon-value" v-html="$t('account.couponDiscount', { value: formatDiscount(coupon.discount) })" />
								</td>
								<td class="account__coupon-cell">
									<i18n
										path="account.couponCode"
										tag="span"
										class="account__coupon-code"
									>
										<template #code>
											<span class="account__coupon-code-value" v-html="coupon.code"/>
										</template>
									</i18n>
								</td>
							</tr>
						</table>
						<h3
							v-else
							class="account__block-text"
							v-html="$t('account.noCoupons')"
						/>
					</div>

					<a class="anchor" id="referral" v-if="hasFeature('FEATURE_REFERRAL') && accountReferralUrl"/>
					<div
						class="account__block insicht insicht--fade-in"
						v-if="hasFeature('FEATURE_REFERRAL') && accountReferralUrl"
					>
						<h2 class="account__block-title" v-html="$t('account.referral.title')"/>

						<div class="account__referral">
							<div class="account__referral-image">
								<div class="media-container media-container--ratio-4-3">
									<img
										:src="referralImage.src"
										:srcset="referralImage.srcset"
										alt="Referral Image"
										data-object-fit
										loading="lazy"
									>
								</div>
							</div>
							<div class="account__referral-content">
								<div class="account__block-text" v-html="$t('account.referral.text')"/>
								<span
									class="account__referral-token"
									v-html="accountReferralUrl"
									@click.prevent="onReferralTokenClick"
								/>

								<Button
									level="primary"
									:text="$t('account.referral.whatsappButton')"
									icon="whatsapp"
									:href="whatsappShare()"
									target="_blank"
									:variants="[
										'small'
									]"
								/>
								<Button
									level="primary"
									icon="envelope"
									:text="$t('account.referral.emailButton')"
									:href="emailShare()"
									:variants="[
										'small'
									]"
								/>
							</div>
						</div>
					</div>

					<a class="anchor" id="orders"/>
					<div class="account__block insicht insicht--fade-in">
						<h2 class="account__block-title" v-html="$t('account.ordersTitle')"/>
						<div
							class="account__orders"
							v-if="lastOrders.length"
						>
							<table
								class="account__orders-table"
							>
								<tr class="account__orders-header">
									<th
										class="account__orders-header-col"
										v-html="$t('account.orderDate')"
									/>
									<th
										class="account__orders-header-col"
										v-html="$t('account.orderTotal')"
									/>
								</tr>
								<tr
									class="account__orders-row"
									v-for="order in lastOrders"
									:key="order.token"
								>
									<td
										class="account__orders-row-col"
									>
										<a
											:href="order.url"
											target="_blank"
											v-html="formatDate(order.checkoutCompletedAt)"
										/>
									</td>
									<td
										class="account__orders-row-col"
										v-html="$options.filters.madpricecent(order.total, 'html')"
									/>
								</tr>
							</table>
						</div>
						<h3
							v-else
							class="account__block-text"
							v-html="$t('account.noOrders')"
						/>
					</div>
				</div>
			</div>
		</template>

		<div
			class="account__wrapper insicht insicht--fade-in"
			v-else-if="initialized && !isLoggedIn"
		>
			<div class="text-block text-block--center">
				<h1 class="text-block__title" v-html="$t('account.notLoggedIn.title')"/>
				<div class="text-block__text">
					<p v-html="$t('account.notLoggedIn.text')"/>
				</div>
				<Button
					level="primary"
					:text="$t('account.notLoggedIn.button')"
					@click="onLogin"
				/>
			</div>
		</div>

		<Modal
			ref="userDetailModal"
			overlay-type="user-detail-edit"
			:html-classes="['hide--header', 'show--modal']"
			narrow
			soft-close
			@softclose="onUserDetailEditSoftClose"
		>

			<OverlayUserDetailEdit
				ref="overlayUserDetailEdit"
				@close="onUserDetailEditClose"
			/>

		</Modal>

		<Modal
			ref="addressModal"
			overlay-type="address-edit"
			:html-classes="['hide--header', 'show--modal']"
			narrow
			soft-close
			@softclose="onAddressEditSoftClose"
		>

			<OverlayAddressEdit
				ref="overlayAddressEdit"
				@close="onAddressEditClose"
			/>

		</Modal>

		<Modal
			ref="passwordModal"
			overlay-type="password-change"
			:html-classes="['hide--header', 'show--modal']"
			narrow
			soft-close
			@softclose="onPasswordChangeSoftClose"
		>
			<div class="overlay-dialog">
				<FormPasswordReset
					ref="passwordChange"
				/>
			</div>
		</Modal>

	</section>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import { ValidationProvider, ValidationObserver } from "vee-validate"
import veevalidate from "@/helpers/veevalidate"
import GenericMixin from '@/mixins/GenericVueMixin'
import FormInputDate from '@/components/FormInputDate'
import FormInputRadio from '@/components/FormInputRadio'
import FormPasswordReset from '@/components/FormPasswordReset'
import OverlayAddressEdit from '@/pages/OverlayAddressEdit'
import OverlayUserDetailEdit from '@/pages/OverlayUserDetailEdit'
import Button from '@/components/Button'
import GeneralMessage from '@/components/GeneralMessage'
import Modal from '@/components/Modal'
import leadingZero from '@/utils/leadingZero'
import sleep from '@/utils/sleep'
import htmlComponent from "htmlcomponent";
import { Glide, GlideSlide } from 'vue-glide-js'
import {eventhub, EVENT_ACCOUNT_ISLOGGEDIN} from '@/store/eventhub'
import scrrroll from 'scrrroll'



export default {
	mixins: [
		GenericMixin,
	],
	components: {
		Modal,
		OverlayAddressEdit,
		OverlayUserDetailEdit,
		FormPasswordReset,
		ValidationObserver,
		ValidationProvider,
		FormInputDate,
		FormInputRadio,
		Button,
		GeneralMessage,
		'vue-glide': Glide,
		'vue-glide-slide': GlideSlide,
	},
	data() {
		return {
			initialized: false,
			glideOptions: {
				bullet: true,
				type: 'slider',
				startAt: 0,
				perView: 3,
				breakpoints: {
					1439: {
						perView: 2,
					},
					1023: {
						perView: 3,
					},
					767: {
						perView: 1,
					}
				},
				gap: 0,
				autoplay: 0,
				hoverpause: true,
				keyboard: false,
				bound: true,
				swipeThreshold: 80,
				dragThreshold: 120,
				perTouch: 0,
				touchRatio: 0.5,
				touchAngle: 45,
				animationDuration: 100,
				rewind: false,
				peek: 0,
			},
			redeemResponse: {
				type: 'info',
				message: '',
			},
			scrolled: false,
		}
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"lastOrders",
			"accountLastAddress",
			"accountUserDetail",
			"accountCoupons",
			"accountClaimableCoupons",
			"accountClub",
			"accountReferralUrl",
			"accountReferralCount",
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		formattedAddress() {
			const userAddress = {
				...this.accountUserDetail,
				...this.accountLastAddress,
			}
			let address = [
				`${userAddress.firstName} ${userAddress.lastName}`
			];

			if (userAddress.street || userAddress.streetNumber) {
				const streetNumber = [
					userAddress.street || '',
					userAddress.streetNumber || ''
				];

				if (this.themeValue('THEME_REVERSE_STREET_NUMBER')) {
					streetNumber.reverse();
				}

				address.push(streetNumber.join(' '));
			}

			if (userAddress.postcode || userAddress.city) {
				address.push(`${userAddress.postcode || ''} ${userAddress.city || ''}`);
			}

			if (userAddress.company) {
				address.unshift(this.accountLastAddress.company);
			}

			if (userAddress.phoneNumber) {
				address.push(`☎ ${userAddress.phoneNumber}`);
			}

			if (userAddress.birthday) {
				address.push(this.$t('account.birthday', { birthday: userAddress.birthday }))
			}


			return address.join('<br>');
		},
		userDetailsFormatted() {
			let details = [
				`${this.accountUserDetail.firstName} ${this.accountUserDetail.lastName}`,
				this.accountUserDetail.email,
			];

			if (this.accountUserDetail.phoneNumber) {
				details.push(`☎ ${this.accountUserDetail.phoneNumber}`);
			}

			return details.join('<br>');
		},
		referralImage() {
			return this.$root.options.referral?.image?.src
				? this.$root.options.referral.image
				: {src: `/files/${this.themeName}/images/referral.jpg`};
		}
	},
	methods: {
		getCouponImage(code) {
			return `/files/${this.themeName}/images/coupons/${code}.jpg`;
		},
		async redeemCoupon(coupon) {
			const confirmed = await this.$store.dispatch('dialog/showDialog', {
				title: this.$t('account.kangaroo.coupons.confirmTitle', {points: coupon.points}),
				message: this.$t('account.kangaroo.coupons.confirmMessage', {points: coupon.points}),
				confirm: this.$t('account.kangaroo.coupons.confirmYes'),
				cancel: this.$t('account.kangaroo.coupons.confirmNo'),
			});
			if (confirmed) {
				this.loading = true;
				try {
					await this.$store.dispatch('account/claimCoupon', { code: coupon.code });
					this.redeemResponse.message = this.$t('account.kangaroo.coupons.success', { value: this.formatDiscount(coupon.amount) });
					this.redeemResponse.type = 'success';
				}
				catch(err) {
					// console.log(err);
					this.$store.dispatch('dialog/showDialog', {
						title: this.$t('forms.errors.error'),
						message: this.$t('forms.errors.generic'),
						confirm: 'OK',
					});
				}
				this.loading = false;
			}
		},
		onLogin() {
			htmlComponent.send('overlay:open', {type: 'login'});
		},
		onLogout() {
			this.$store.dispatch('logout')
		},
		onUserDetailEdit() {
			this.$refs.userDetailModal.open();
		},
		onUserDetailEditSoftClose() {
			this.$refs.overlayUserDetailEdit.onClose();
		},
		onUserDetailEditClose() {
			this.$refs.userDetailModal.close();
		},
		onAddressEdit() {
			this.$refs.addressModal.open();
		},
		onAddressEditSoftClose() {
			this.$refs.overlayAddressEdit.onClose();
		},
		onAddressEditClose() {
			this.$refs.addressModal.close();
		},
		onPasswordChange() {
			this.$refs.passwordModal.open();
		},
		async onPasswordChangeSoftClose() {
			if (this.$refs.passwordChange.edited) {
				const confirmed = await this.$store.dispatch('dialog/showDialog', {
					title: this.$t('account.resetPassword.dialogTitle'),
					message: this.$t('account.resetPassword.dialogMessage'),
					confirm: this.$t('account.resetPassword.dialogConfirm'),
					cancel: this.$t('account.resetPassword.dialogCancel'),
				});
				if (confirmed) {
					return;
				}
			}
			this.$refs.passwordModal.close();
		},
		onReferralTokenClick(e) {
			let range = document.createRange();
			range.selectNodeContents(e.target);
			let sel = window.getSelection();
			sel.removeAllRanges();
			sel.addRange(range);
		},
		whatsappShare() {
			let url = 'https://api.whatsapp.com/send?text=';
			let text = this.$t('account.referral.whatsappText', { url: this.accountReferralUrl }).replace(/\\n/ig, '\n');
			return `${url}${encodeURIComponent(text)}`;
		},
		emailShare() {
			let subject = this.$t('account.referral.emailSubject');
			let text = this.$t('account.referral.emailText', { url: this.accountReferralUrl }).replace(/\\n/ig, '\n');
			return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`;
		},
		formatDate(date) {
			const d = new Date(date);
			const day = leadingZero(d.getDate());
			const month = leadingZero(d.getMonth() + 1);
			const year = d.getFullYear();

			return `${day}.${month}.${year}`;
		},
		formatDiscount(discount) {
			discount = '' + discount;
			if (discount.indexOf('%') < 0) {
				// multiply by 100 because coupon is in francs rather than cents
				discount = this.$options.filters.madpricecent(discount * 100, 'html')
			}
			return discount;
		},
		async onIsLoggedIn() {
			await this.$nextTick();
			this.handleAnchor();
		},
		handleAnchor() {
			if (!this.scrolled && this.initialized) {
				const hash = location.hash;
				if (hash.length > 1) {
					const anchor = document.querySelector(hash);
					if (anchor) {
						this.scrolled = true;
						scrrroll.to(Math.ceil(anchor.getBoundingClientRect().top + window.pageYOffset));
					}
				}
			}
		}
	},
	async created() {
		this.loading = true;
		try {
			await this.$store.dispatch("initializeAccount")
			this.initialized = true;
		}
		catch(err) {
			this.$store.dispatch('dialog/showDialog', {
				title: this.$t('forms.errors.error'),
				message: this.$t('forms.errors.generic'),
				confirm: 'OK',
			});
		}
		this.loading = false;
		await this.$nextTick();
		this.handleAnchor();
	},
	async updated() {
		await this.$nextTick();
		this.handleAnchor();
	},
	async mounted() {
		eventhub.$on(EVENT_ACCOUNT_ISLOGGEDIN, this.onIsLoggedIn)
		await this.$nextTick();
		this.handleAnchor();
	},
	destroyed() {
		eventhub.$off(EVENT_ACCOUNT_ISLOGGEDIN, this.onIsLoggedIn)
	},
};
</script>

<style>
</style>
